<template>
  <v-card
    :width="width"
    :min-width="width"
    style="height: 100%;"
  >
    <v-navigation-drawer
      :width="width"
      :color="color"
      :dark="dark"
      permanent
      absolute
    >
      <v-list class="vertical-menu">
        <div class="vertical-menu__header cursor" @click="setSideMenuHide">
          <slot name="header" />
        </div>

        <div class="vertical-menu__body">
          <template v-for="( menu, i) in menus">
            <template
              v-if="utilManager.isEmpty(menu.permission) || userManager.hasPermission(menu.permission)"
            >
              <!-- 메뉴 그룹 -->
              <v-list-group
                v-if="utilManager.isNotEmpty(menu.children)"
                :key="'menu-' + i"
                :color="listItemGroupColor"
              >
                <template v-slot:activator>
                  <v-icon v-if="menu.icon" class="mr-2">
                    {{ menu.icon }}
                  </v-icon>
                  <v-list-item-title>{{ menu.text | translate }}</v-list-item-title>
                </template>

                <template v-for="(child, j) in menu.children">
                  <template
                    v-if="utilManager.isEmpty(child.permission) || userManager.hasPermission(child.permission)"
                  >
                    <!-- 자식 그룹 -->
                    <v-list-group
                      v-if="utilManager.isNotEmpty(child.subChildren)"
                      :key="'children-' + j"
                      no-action
                      sub-group
                      :color="listItemGroupColor"
                      :style="groupStyle"
                    >
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-list-item-title>{{ child.text | translate }}</v-list-item-title>
                        </v-list-item-content>
                      </template>

                      <!-- 손자 목록 -->
                      <v-list-item
                        v-for="(subChild, k) in child.subChildren"
                        :key="'sub-children-' + k"
                        link
                        @click="onClick(subChild)"
                      >
                        <template
                          v-if="utilManager.isEmpty(subChild.permission) || userManager.hasPermission(subChild.permission)"
                        >
                          <!-- 손자 타이틀 -->
                          <v-list-item-title>
                            {{ subChild.text | translate }}
                          </v-list-item-title>
                        </template>
                      </v-list-item>
                    </v-list-group>


                    <!-- 자식 단일 메뉴 -->
                    <!-- 손자 목록 -->
                    <v-list-item v-else :key="'children-' + j" class="pl-9" :class="{ 'menu-current': $route.name === child.id }" :style="groupStyle"
                                 @click="onClick(child)"
                    >
                      <v-list-item-title>
                        {{ child.text | translate }}
                        <menu-beta-badge v-if="isBetaMenuLink(child.id)" />
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </template>
              </v-list-group>

              <!-- 단일 메뉴 타이틀 -->
              <v-list-item v-else :key="'menu-' + i" link :class="{ 'menu-current': $route.name === menu.id }" @click="onClick(menu)">
                <v-icon v-if="menu.icon" class="mr-2">
                  {{ menu.icon }}
                </v-icon>
                <v-list-item-title>{{ menu.text | translate }}</v-list-item-title>
              </v-list-item>
            </template>
          </template>
        </div>

        <div class="vertical-menu__footer">
          <slot name="footer" />
        </div>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
import MenuBetaBadge from '@/components/common/MenuBetaBadge.vue'
import { isBetaMenuLink } from '@/constants/betaMenus'

export default {
  name: "MultiChildrenVerticalMenu",
  components: { MenuBetaBadge },
  props: {
    width: {
      type: String,
      default: "250px",
    },
    menus: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: "#2B3F54",
    },
    dark: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    groupStyle() {
      return {
        backgroundColor: this.listItemGroupBackgroundColor,
      }
    },

    /**
     * 자식 그룹의 background color
     */
    listItemGroupBackgroundColor() {
      return this.dark ? "rgba(255,255,255,0.1)" : undefined;
    },

    /**
     * 자식 그룹의 텍스트 color
     */
    listItemGroupColor() {
      return this.dark ? "white" : undefined;
    },
  },
  methods: {
    isBetaMenuLink,
    onClick(menu) {
      this.$emit('click', menu);
    },
    setSideMenuHide() {
      this.$emit('setSideMenuHide');
    },
    movePageMain() {
      this.$emit('movePageMain');
    }

  },
}
</script>

<style scoped>
.cursor {
  cursor: pointer;
}

.vertical-menu {
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.vertical-menu__header {
  flex-grow: 0;
}

.vertical-menu__body {
  flex-grow: 1;
  overflow-y: auto;
}

.vertical-menu__footer {
  padding-top: 20px;
  flex-grow: 0;
}

.logo_tnbox {
  display: flex;
}

.logo_tnbox > img {
  width: 22px;
}

.logo_tnbox > div {
  line-height: 22px;
}

.vertical_menu_top_section {
  padding: 20px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.vertical_menu_top_section_text {
  font-size: 1.5rem;
}

.active_menu_class {
  background-color: rgba(255, 255, 255, 0.7);
}
.menu-current {
  background-color: rgba(15, 118, 110, 0.55);
  box-shadow: inset 3px 0 0 #99f6e4;
}
</style>